// // src/pages/treatments/LiverTransplantPage.jsx
// import React from "react";
// import TreatmentTemplate from "./TreatmentTemplate";
// import { Award, Users, Shield, Clock, Calendar, Activity, ThumbsUp, Heart } from "lucide-react";

// const LIVER_TRANSPLANT_TREATMENT = {
//   slug: "liver-transplant",
//   name: "Liver Transplant",
//   shortName: "Liver Transplant",
//   tagline: "A Second Chance at Life. Expert Hands. Proven Outcomes.",
//   heroSubtag:
//     "World-class liver transplant surgery at a fraction of Western costs. India's top hepatobiliary surgeons. Life-saving outcomes.",
//   description:
//     "Comprehensive liver transplant care covering living donor, deceased donor and split liver transplants — supported by advanced hepatology, intensive care, and lifelong post-transplant follow-up. Our multidisciplinary transplant boards review every case to deliver globally benchmarked, personalised treatment plans with exceptional survival rates.",
//   heroImage: "/LiverTransplant.jpeg",
//   category: "Organ Transplant",
//   badge: "Life-Saving Surgery",
//   accentColor: "amber",
//   costCard: {
//     label: "Liver transplant packages",
//     value: "₹20L–₹35L",
//     compare: "vs. £150,000–£250,000 in the UK",
//     stay: "Typically 6–8 weeks in India post-surgery",
//     stayCompare: "vs. $300,000–$500,000 in the USA",
//   },
//   stats: [
//     { label: "1-Year Survival Rate", value: "92%+", icon: Award },
//     { label: "Transplants Performed", value: "5,000+", icon: Users },
//     { label: "Years Experience", value: "25+", icon: Shield },
//     { label: "Avg. Wait for Living Donor", value: "4–6 Wks", icon: Clock },
//   ],
//   benefits: [
//     "Living donor and deceased donor liver transplant programmes",
//     "Split liver transplantation for paediatric and adult recipients",
//     "Advanced hepatobiliary surgery — laparoscopic donor hepatectomy",
//     "Dedicated liver ICU with 24/7 hepatologist and transplant surgeon cover",
//     "Comprehensive donor workup — medical, surgical, psychological and ethical evaluation",
//     "Immunosuppression management and lifelong post-transplant monitoring",
//     "MELD score prioritisation and urgent listing for acute liver failure",
//     "Multidisciplinary tumour board for hepatocellular carcinoma (HCC) cases",
//   ],
//   procedure: [
//     {
//       step: "01",
//       title: "Evaluation & Listing",
//       desc: "Complete hepatic workup — MELD scoring, imaging, cardiac and pulmonary clearance, donor matching and transplant committee approval.",
//       duration: "1–2 Weeks",
//       icon: Calendar,
//     },
//     {
//       step: "02",
//       title: "Donor Assessment",
//       desc: "Living donor undergoes full medical, surgical, psychological and ethical evaluation to confirm safe resection volumes.",
//       duration: "1–2 Weeks",
//       icon: Activity,
//     },
//     {
//       step: "03",
//       title: "Transplant Surgery",
//       desc: "Simultaneous donor hepatectomy and recipient transplant by senior hepatobiliary surgeons under general anaesthesia.",
//       duration: "10–14 Hours",
//       icon: ThumbsUp,
//     },
//     {
//       step: "04",
//       title: "Recovery & Follow-Up",
//       desc: "Liver ICU stay, immunosuppression initiation, rejection monitoring and discharge planning with lifelong outpatient follow-up protocol.",
//       duration: "6–8 Weeks",
//       icon: Heart,
//     },
//   ],
//   faqs: [
//     {
//       q: "Who needs a liver transplant?",
//       a: "Liver transplant is indicated for end-stage liver disease (cirrhosis from hepatitis B, hepatitis C, alcohol or NASH), acute liver failure, hepatocellular carcinoma (within Milan criteria), biliary atresia in children, and metabolic liver diseases such as Wilson's disease.",
//     },
//     {
//       q: "What is a living donor liver transplant?",
//       a: "A healthy family member (typically aged 18–55, blood group compatible) donates 60–70% of their liver (the right lobe) to the recipient. The liver regenerates to near-full size in both donor and recipient within 6–8 weeks. India is one of the world leaders in living donor liver transplant volume and outcomes.",
//     },
//     {
//       q: "What is the survival rate after liver transplant in India?",
//       a: "Leading Indian transplant centres report 1-year patient survival rates of 90–95% and 5-year survival rates of 80–85% — on par with the best centres in the USA and Europe. Outcomes for living donor transplants are generally slightly better than deceased donor transplants.",
//     },
//     {
//       q: "How long will I need to stay in India?",
//       a: "Recipients typically stay 6–8 weeks post-surgery for close monitoring, immunosuppression adjustment and liver function stabilisation before being cleared to fly. The living donor is usually discharged within 7–10 days. PaxGrow arranges serviced accommodation near the hospital for accompanying family.",
//     },
//     {
//       q: "What are the risks to the living donor?",
//       a: "Donor hepatectomy carries a mortality risk of approximately 0.1–0.5% at high-volume centres, with a complication rate of 10–15% (mostly minor — bile leak, wound infection). Every donor undergoes rigorous pre-operative evaluation by an independent team to confirm safety. Donors are usually back to full activity within 6–8 weeks.",
//     },
//     {
//       q: "How much does liver transplant cost in India vs. the UK or USA?",
//       a: "A complete liver transplant package in India (including surgery, ICU, hospital stay, immunosuppression and follow-up) typically costs ₹20L–₹35L ($25,000–$45,000), compared to £150,000–£250,000 in the UK and $300,000–$500,000 in the USA — with equivalent or superior survival outcomes at top Indian centres.",
//     },
//     {
//       q: "Can I bring my own donor from my home country?",
//       a: "Yes. Many international patients bring a family member as the living donor. PaxGrow arranges medical visas for both recipient and donor simultaneously. The donor undergoes full evaluation at the Indian hospital before surgery is confirmed.",
//     },
//   ],
//   doctors: [
//     {
//       name: "Dr. A. S. Soin",
//       specialty: "Liver Transplant & HPB Surgery",
//       experience: "30 Years",
//       rating: 4.9,
//       reviews: 3800,
//       image: "https://randomuser.me/api/portraits/men/52.jpg",
//       qualifications: "MBBS, MS, MCh (HPB), FRCS (Edinburgh)",
//       hospital: "Medanta — The Medicity, Gurgaon",
//     },
//     {
//       name: "Dr. Subash Gupta",
//       specialty: "Liver Transplant Surgery",
//       experience: "28 Years",
//       rating: 4.9,
//       reviews: 2900,
//       image: "https://randomuser.me/api/portraits/men/63.jpg",
//       qualifications: "MBBS, MS (Surgery), MCh, FRCS",
//       hospital: "Max Super Speciality Hospital, Delhi",
//     },
//     {
//       name: "Dr. Rela Mohamed",
//       specialty: "Paediatric & Adult Liver Transplant",
//       experience: "32 Years",
//       rating: 4.9,
//       reviews: 4100,
//       image: "https://randomuser.me/api/portraits/men/71.jpg",
//       qualifications: "MBBS, MS, FRCS (England), PhD",
//       hospital: "Dr. Rela Institute, Chennai",
//     },
//   ],
//   testimonials: [
//     {
//       name: "Emmanuel Okafor",
//       age: 48,
//       location: "Lagos, Nigeria",
//       text: "My MELD score was 28 and doctors at home said I had months to live. PaxGrow got my reports reviewed within 24 hours and had me in Delhi within two weeks. My brother donated a portion of his liver. Eight months later I am back working full time. I owe my life to this team.",
//       rating: 5,
//       image: "https://randomuser.me/api/portraits/men/44.jpg",
//       treatment: "Living Donor Liver Transplant — Hepatitis B Cirrhosis",
//       date: "November 2023",
//     },
//     {
//       name: "Zainab Al-Farsi",
//       age: 39,
//       location: "Muscat, Oman",
//       text: "My 9-year-old daughter had biliary atresia and was deteriorating fast. The paediatric transplant team in Chennai performed a split liver transplant. She is now in school and completely healthy. The care we received was extraordinary.",
//       rating: 5,
//       image: "https://randomuser.me/api/portraits/women/58.jpg",
//       treatment: "Paediatric Split Liver Transplant — Biliary Atresia",
//       date: "January 2024",
//     },
//     {
//       name: "David Mwangi",
//       age: 52,
//       location: "Nairobi, Kenya",
//       text: "Alcoholic cirrhosis with hepatocellular carcinoma. I was told I was too complex for local treatment. The tumour board at Medanta reviewed my scans overnight and confirmed I was within Milan criteria for transplant. One year post-surgery and my scans are completely clear.",
//       rating: 5,
//       image: "https://randomuser.me/api/portraits/men/77.jpg",
//       treatment: "Liver Transplant — HCC within Milan Criteria",
//       date: "March 2024",
//     },
//   ],
// };

// const LIVER_TRANSPLANT_PAXGROW = {
//   whyIndiaSubtitle: "WHY PAXGROW + INDIA",
//   whyIndiaTitle: "Why African & Gulf Patients Choose India for Liver Transplant",
//   whyIndiaReasons: [
//     "India performs more living donor liver transplants than any country outside South Korea — with 90–95% one-year survival at top centres",
//     "Multidisciplinary transplant boards review international cases within 48 hours of receiving reports",
//     "Surgery confirmed within 4–6 weeks for living donor cases — no deceased donor waiting lists of years as in the West",
//     "Medanta, Max, Apollo, Fortis, Dr. Rela Institute — globally ranked hepatobiliary programmes with full outcome transparency",
//   ],
//   conditionsTitle: "Liver Conditions We Facilitate Transplant Treatment For",
//   conditions: [
//     "Liver Cirrhosis (Hepatitis B & C)",
//     "Alcoholic Liver Disease",
//     "Non-Alcoholic Steatohepatitis (NASH)",
//     "Hepatocellular Carcinoma (HCC)",
//     "Acute Liver Failure",
//     "Biliary Atresia (Paediatric)",
//     "Primary Biliary Cholangitis (PBC)",
//     "Primary Sclerosing Cholangitis (PSC)",
//     "Wilson's Disease",
//     "Autoimmune Hepatitis",
//     "Budd-Chiari Syndrome",
//     "Cryptogenic Cirrhosis",
//   ],
//   stayValue:
//     "Recipients: 6–8 weeks post-surgery. Living donors: 10–14 days. PaxGrow arranges serviced accommodation for accompanying family throughout.",
//   costTitle: "Why India for Liver Transplant?",
//   costRows: [
//     {
//       procedure: "Living Donor Liver Transplant (full package)",
//       india: "₹20L–₹30L",
//       africa: "Largely unavailable",
//       ukusa: "$300,000–$500,000",
//     },
//     {
//       procedure: "Deceased Donor Liver Transplant",
//       india: "₹25L–₹35L",
//       africa: "Largely unavailable",
//       ukusa: "$350,000–$550,000",
//     },
//     {
//       procedure: "Paediatric Liver Transplant",
//       india: "₹18L–₹28L",
//       africa: "Largely unavailable",
//       ukusa: "$250,000–$450,000",
//     },
//     {
//       procedure: "Liver ICU (per day)",
//       india: "₹15,000–₹30,000",
//       africa: "$500–$1,500",
//       ukusa: "$5,000–$10,000",
//     },
//     {
//       procedure: "Post-Transplant Immunosuppression (per month)",
//       india: "₹8,000–₹20,000",
//       africa: "$800–$2,000",
//       ukusa: "$2,000–$5,000",
//     },
//   ],
// };

// const LiverTransplantPage = () => {
//   return (
//     <TreatmentTemplate
//       treatment={LIVER_TRANSPLANT_TREATMENT}
//       paxgrowData={LIVER_TRANSPLANT_PAXGROW}
//     />
//   );
// };

// export default LiverTransplantPage;

// src/pages/treatments/LiverTransplantPage.jsx
import React from "react";
import TreatmentTemplate from "./TreatmentTemplate";
import { Award, Users, Shield, Clock, Calendar, Activity, ThumbsUp, Heart } from "lucide-react";

const LIVER_TRANSPLANT_TREATMENT = {
  slug: "liver-transplant",
  name: "Liver Transplant",
  shortName: "Liver Transplant",
  tagline: "A Second Chance at Life. Expert Hands. Proven Outcomes.",
  heroSubtag:
    "World-class liver transplant surgery at a fraction of Western costs. India's top hepatobiliary surgeons. Life-saving outcomes.",
  description:
    "Comprehensive liver transplant care covering living donor, deceased donor and split liver transplants — supported by advanced hepatology, intensive care, and lifelong post-transplant follow-up. Our multidisciplinary transplant boards review every case to deliver globally benchmarked, personalised treatment plans with exceptional survival rates.",
  heroImage: "/LiverTransplant.jpeg",
  category: "Organ Transplant",
  badge: "Life-Saving Surgery",
  accentColor: "amber",
  costCard: {
    label: "Liver transplant packages",
    value: "$24,000–$42,000",
    compare: "vs. $180,000–$300,000 in the UK",
    stay: "Typically 6–8 weeks in India post-surgery",
    stayCompare: "vs. $300,000–$500,000 in the USA",
  },
  stats: [
    { label: "1-Year Survival Rate", value: "92%+", icon: Award },
    { label: "Transplants Performed", value: "5,000+", icon: Users },
    { label: "Years Experience", value: "25+", icon: Shield },
    { label: "Avg. Wait for Living Donor", value: "4–6 Wks", icon: Clock },
  ],
  benefits: [
    "Living donor and deceased donor liver transplant programmes",
    "Split liver transplantation for paediatric and adult recipients",
    "Advanced hepatobiliary surgery — laparoscopic donor hepatectomy",
    "Dedicated liver ICU with 24/7 hepatologist and transplant surgeon cover",
    "Comprehensive donor workup — medical, surgical, psychological and ethical evaluation",
    "Immunosuppression management and lifelong post-transplant monitoring",
    "MELD score prioritisation and urgent listing for acute liver failure",
    "Multidisciplinary tumour board for hepatocellular carcinoma (HCC) cases",
  ],
  procedure: [
    {
      step: "01",
      title: "Evaluation & Listing",
      desc: "Complete hepatic workup — MELD scoring, imaging, cardiac and pulmonary clearance, donor matching and transplant committee approval.",
      duration: "1–2 Weeks",
      icon: Calendar,
    },
    {
      step: "02",
      title: "Donor Assessment",
      desc: "Living donor undergoes full medical, surgical, psychological and ethical evaluation to confirm safe resection volumes.",
      duration: "1–2 Weeks",
      icon: Activity,
    },
    {
      step: "03",
      title: "Transplant Surgery",
      desc: "Simultaneous donor hepatectomy and recipient transplant by senior hepatobiliary surgeons under general anaesthesia.",
      duration: "10–14 Hours",
      icon: ThumbsUp,
    },
    {
      step: "04",
      title: "Recovery & Follow-Up",
      desc: "Liver ICU stay, immunosuppression initiation, rejection monitoring and discharge planning with lifelong outpatient follow-up protocol.",
      duration: "6–8 Weeks",
      icon: Heart,
    },
  ],
  faqs: [
    {
      q: "Who needs a liver transplant?",
      a: "Liver transplant is indicated for end-stage liver disease (cirrhosis from hepatitis B, hepatitis C, alcohol or NASH), acute liver failure, hepatocellular carcinoma (within Milan criteria), biliary atresia in children, and metabolic liver diseases such as Wilson's disease.",
    },
    {
      q: "What is a living donor liver transplant?",
      a: "A healthy family member (typically aged 18–55, blood group compatible) donates 60–70% of their liver (the right lobe) to the recipient. The liver regenerates to near-full size in both donor and recipient within 6–8 weeks. India is one of the world leaders in living donor liver transplant volume and outcomes.",
    },
    {
      q: "What is the survival rate after liver transplant in India?",
      a: "Leading Indian transplant centres report 1-year patient survival rates of 90–95% and 5-year survival rates of 80–85% — on par with the best centres in the USA and Europe. Outcomes for living donor transplants are generally slightly better than deceased donor transplants.",
    },
    {
      q: "How long will I need to stay in India?",
      a: "Recipients typically stay 6–8 weeks post-surgery for close monitoring, immunosuppression adjustment and liver function stabilisation before being cleared to fly. The living donor is usually discharged within 7–10 days. PaxGrow arranges serviced accommodation near the hospital for accompanying family.",
    },
    {
      q: "What are the risks to the living donor?",
      a: "Donor hepatectomy carries a mortality risk of approximately 0.1–0.5% at high-volume centres, with a complication rate of 10–15% (mostly minor — bile leak, wound infection). Every donor undergoes rigorous pre-operative evaluation by an independent team to confirm safety. Donors are usually back to full activity within 6–8 weeks.",
    },
    {
      q: "How much does liver transplant cost in India vs. the UK or USA?",
      a: "A complete liver transplant package in India (including surgery, ICU, hospital stay, immunosuppression and follow-up) typically costs $25,000–$45,000, compared to $180,000–$300,000 in the UK and $300,000–$500,000 in the USA — with equivalent or superior survival outcomes at top Indian centres.",
    },
    {
      q: "Can I bring my own donor from my home country?",
      a: "Yes. Many international patients bring a family member as the living donor. PaxGrow arranges medical visas for both recipient and donor simultaneously. The donor undergoes full evaluation at the Indian hospital before surgery is confirmed.",
    },
  ],
  doctors: [
    {
      name: "Dr. A. S. Soin",
      specialty: "Liver Transplant & HPB Surgery",
      experience: "30 Years",
      rating: 4.9,
      reviews: 3800,
      image: "https://randomuser.me/api/portraits/men/52.jpg",
      qualifications: "MBBS, MS, MCh (HPB), FRCS (Edinburgh)",
      hospital: "Medanta — The Medicity, Gurgaon",
    },
    {
      name: "Dr. Subash Gupta",
      specialty: "Liver Transplant Surgery",
      experience: "28 Years",
      rating: 4.9,
      reviews: 2900,
      image: "https://randomuser.me/api/portraits/men/63.jpg",
      qualifications: "MBBS, MS (Surgery), MCh, FRCS",
      hospital: "Max Super Speciality Hospital, Delhi",
    },
    {
      name: "Dr. Rela Mohamed",
      specialty: "Paediatric & Adult Liver Transplant",
      experience: "32 Years",
      rating: 4.9,
      reviews: 4100,
      image: "https://randomuser.me/api/portraits/men/71.jpg",
      qualifications: "MBBS, MS, FRCS (England), PhD",
      hospital: "Dr. Rela Institute, Chennai",
    },
  ],
  testimonials: [
    {
      name: "Emmanuel Okafor",
      age: 48,
      location: "Lagos, Nigeria",
      text: "My MELD score was 28 and doctors at home said I had months to live. PaxGrow got my reports reviewed within 24 hours and had me in Delhi within two weeks. My brother donated a portion of his liver. Eight months later I am back working full time. I owe my life to this team.",
      rating: 5,
      image: "https://randomuser.me/api/portraits/men/44.jpg",
      treatment: "Living Donor Liver Transplant — Hepatitis B Cirrhosis",
      date: "November 2023",
    },
    {
      name: "Zainab Al-Farsi",
      age: 39,
      location: "Muscat, Oman",
      text: "My 9-year-old daughter had biliary atresia and was deteriorating fast. The paediatric transplant team in Chennai performed a split liver transplant. She is now in school and completely healthy. The care we received was extraordinary.",
      rating: 5,
      image: "https://randomuser.me/api/portraits/women/58.jpg",
      treatment: "Paediatric Split Liver Transplant — Biliary Atresia",
      date: "January 2024",
    },
    {
      name: "David Mwangi",
      age: 52,
      location: "Nairobi, Kenya",
      text: "Alcoholic cirrhosis with hepatocellular carcinoma. I was told I was too complex for local treatment. The tumour board at Medanta reviewed my scans overnight and confirmed I was within Milan criteria for transplant. One year post-surgery and my scans are completely clear.",
      rating: 5,
      image: "https://randomuser.me/api/portraits/men/77.jpg",
      treatment: "Liver Transplant — HCC within Milan Criteria",
      date: "March 2024",
    },
  ],
};

const LIVER_TRANSPLANT_PAXGROW = {
  whyIndiaSubtitle: "WHY PAXGROW + INDIA",
  whyIndiaTitle: "Why African & Gulf Patients Choose India for Liver Transplant",
  whyIndiaReasons: [
    "India performs more living donor liver transplants than any country outside South Korea — with 90–95% one-year survival at top centres",
    "Multidisciplinary transplant boards review international cases within 48 hours of receiving reports",
    "Surgery confirmed within 4–6 weeks for living donor cases — no deceased donor waiting lists of years as in the West",
    "Medanta, Max, Apollo, Fortis, Dr. Rela Institute — globally ranked hepatobiliary programmes with full outcome transparency",
  ],
  conditionsTitle: "Liver Conditions We Facilitate Transplant Treatment For",
  conditions: [
    "Liver Cirrhosis (Hepatitis B & C)",
    "Alcoholic Liver Disease",
    "Non-Alcoholic Steatohepatitis (NASH)",
    "Hepatocellular Carcinoma (HCC)",
    "Acute Liver Failure",
    "Biliary Atresia (Paediatric)",
    "Primary Biliary Cholangitis (PBC)",
    "Primary Sclerosing Cholangitis (PSC)",
    "Wilson's Disease",
    "Autoimmune Hepatitis",
    "Budd-Chiari Syndrome",
    "Cryptogenic Cirrhosis",
  ],
  stayValue:
    "Recipients: 6–8 weeks post-surgery. Living donors: 10–14 days. PaxGrow arranges serviced accommodation for accompanying family throughout.",
  costTitle: "Why India for Liver Transplant?",
  costRows: [
    {
      procedure: "Living Donor Liver Transplant (full package)",
      india: "$24,000–$36,000",
      africa: "Largely unavailable",
      ukusa: "$300,000–$500,000",
    },
    {
      procedure: "Deceased Donor Liver Transplant",
      india: "$30,000–$42,000",
      africa: "Largely unavailable",
      ukusa: "$350,000–$550,000",
    },
    {
      procedure: "Paediatric Liver Transplant",
      india: "$22,000–$34,000",
      africa: "Largely unavailable",
      ukusa: "$250,000–$450,000",
    },
    {
      procedure: "Liver ICU (per day)",
      india: "$180–$360",
      africa: "$500–$1,500",
      ukusa: "$5,000–$10,000",
    },
    {
      procedure: "Post-Transplant Immunosuppression (per month)",
      india: "$100–$240",
      africa: "$800–$2,000",
      ukusa: "$2,000–$5,000",
    },
  ],
};

const LiverTransplantPage = () => {
  return (
    <TreatmentTemplate
      treatment={LIVER_TRANSPLANT_TREATMENT}
      paxgrowData={LIVER_TRANSPLANT_PAXGROW}
    />
  );
};

export default LiverTransplantPage;